import { Box } from '@mui/material';

export function Page(props) {
  return <Box sx={{ padding: '20px' }}>{props.children}</Box>;
}
